export const setVisitorRegion = () => {
	if (!localStorage.getItem('visitorRegion') || !localStorage.getItem('visitorCountry')) {
		return fetch(calendlyData.regionApiUrl + '/api/public/v1/region')
			.then((res) => res.json())
			.then((data) => {
				localStorage.setItem('visitorRegion', data.region.toLowerCase());
				localStorage.setItem('visitorCountry', data.country.toLowerCase());
			});
	}
};

export const sanitizeVisibilityValue = (value) => {
	const values = value.replaceAll(' ', '').split(',');
	return values;
};
